import React, { useContext, useEffect } from "react";
import { debounce } from "debounce";
import { connect } from "react-redux";

import PrimaryIcon from "./PrimaryIcon";
import { selectCurrentModule } from "../App/selectors";
import { selectLoadedUser } from "../../routes/Auth/auth.ducks";
import {
  selectFavoriteIds,
  selectFavorites,
  toggleFavorite
} from "../../routes/Favorite/favorite.ducks";
import ReactGA from "react-ga4";
import { Context } from "../../GAContext";
import { CurrentPage } from "../../models";
import { rootReducerInterface, UserI } from "../../typings/interfaces";
import { AdListFavoriteDataI } from "../../typings/routesTypes";
import { selectCategories } from "../App/selectors";
import useHrPageName from "../../utils/useHrPageName";

interface FavoriteButtonProps {
  ad: AdListFavoriteDataI;
  adLists: { similar: { data: AdListFavoriteDataI[] } };
  category?: string;
  categories: [];
  className: string;
  component: Function;
  wrapper: Function;
  disabled?: boolean;
  favoriteIds: string[];
  flag: string;
  handleFavorite: Function;
  module: string;
  toggleFavorite: Function;
  user: UserI | null;
}

const FavoriteButton = (props: FavoriteButtonProps) => {
  const {
    className,
    ad,
    component: ComponentToRender,
    wrapper: WrapperToRender,
    category,
    flag,
    disabled
  } = props;
  const [GaEvent] = useContext(Context);
  const hrPageName = useHrPageName(ad && ad.category, ad && ad.module);
  
  const debounced = debounce(
    () => {
      const { handleFavorite } = props;

      let label: string;
      let shouldSend = false;      

      if (GaEvent == CurrentPage.home) {
        label = `Spremanje oglasa - najnoviji naslovnica ${hrPageName}`;
        shouldSend = true;
      }
      if (GaEvent == CurrentPage.search) {
        label = `Spremanje oglasa - rezultati pretrage ${hrPageName}`;
        shouldSend = true;
      }
      if (CurrentPage.details && flag == "SpecialSection") {
        label = `Spremanje oglasa - detalji oglasa ${hrPageName}`;
        shouldSend = true;
      }
      if (CurrentPage.details && flag == "SimilarAdsSection") {
        label = `Spremanje oglasa - slični oglasi ${hrPageName}`;
        shouldSend = true;
      }
      if (shouldSend) {
        ReactGA.event({
          category: "Spremanje oglasa",
          action: "Click",
          label: label
        });
      }
      handleFavorite();
    },
    1000,
    true
  );

  useEffect(() => {
    return () => {
      debounced.clear();
    };
  }, []);

  if (WrapperToRender) {
    return (
      <WrapperToRender
        ad={ad}
        handleFavorite={
          disabled
            ? null
            : (e: any) => {
              e.preventDefault();
              debounced();
            }
        }>
        <ComponentToRender
          className={className}
          ad={ad}
        />
      </WrapperToRender>
    );
  } else {
    return (
      <ComponentToRender
        className={className}
        ad={ad}
        handleFavorite={
          disabled
            ? null
            : (e: any) => {
              e.preventDefault();
              debounced();
            }
        }
      />
    );
  }
}

FavoriteButton.defaultProps = {
  component: PrimaryIcon,
  wrapper: null,
  adLists: null,
  ad: null
};

function mapStateToProps(state: rootReducerInterface) {
  return {
    module: selectCurrentModule(state),
    user: selectLoadedUser(state),
    favoriteIds: selectFavoriteIds(state),
    favorites: selectFavorites(state),
    categories: selectCategories(state)
  };
}

function mergeProps(stateProps: any, dispatchProps: any, ownProps: any) {
  const { user, favoriteIds, favorites } = stateProps;
  const { ad, adLists } = ownProps;

  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    handleFavorite() {
      dispatchProps.toggleFavorite(ad, favoriteIds, favorites, adLists, user);
    }
  };
}

const withConnect = connect(mapStateToProps, { toggleFavorite }, mergeProps);

export default withConnect(FavoriteButton);



// WEBPACK FOOTER //
// ./src/containers/FavoriteButton/index.tsx